import $ from "jquery";
//npm install swiper
import Swiper from 'swiper/bundle';

$(function() {
    $(".bl-wl-textwithimage").each(function() {
        const $bl = $(this);
        initBlock($bl);
    });
});

function initBlock($bl) {
    const swiper = new Swiper($bl.find('.swiper').get(0), {
      loop: true,
      //rewind: true,
      //autoHeight: true,

      speed: 1000,
      autoplay: {
        delay: 3000
      }
    });
}
